import { fetchBuildersProjectsData } from '../../services/fetchBuildersProjectsData';
import { TThunkAction } from '../../types/redux';
import { startFetching } from '.';
import { appendBuildersProjectsData } from './appendBuildersProjectsData';

export const loadBuildersProjectsData = (): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    dispatch(startFetching());

    const {
      buildersProjects: {
        data: { location, limit, page },
      },
      filters: { appliedFilters },
    } = getState();

    const data = await fetchBuildersProjectsData(context, {
      ...appliedFilters,
      page: page + 1,
      limit,
      regionId: location?.id,
    });

    dispatch(appendBuildersProjectsData(data));
  };
};
